import {DataApi} from '../data-api';
import {DataApiDistinctValues, DataApiResult, Expertise} from '../../../types/data-api';
import {DataApiEndpoint} from '../data-api-endpoint';
import {ExpertiseFilter, ExpertiseSettings} from '../../../plugins/expertise/list';

/**
 * Endpoint for getting expertises.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class ExpertiseEndpoint extends DataApiEndpoint {
  protected _api: DataApi;

  constructor(api: DataApi) {
    super(api);
    this._api = api;
  }

  /**
   * Finds expertises by a filter.
   *
   * @param {ExpertiseSettings|null} settings Plugin settings
   * @param {ExpertiseFilter|null} [filter] Filter
   * @returns {Promise<DataApiResult<ExpertiseEndpoint>>}
   */
  public async find(
    settings: ExpertiseSettings | null = null,
    filter: ExpertiseFilter | null = null
  ): Promise<DataApiResult<Expertise>> {
    return fetch(this.buildUrl(settings, filter, [
      'dataApi[preset]=expertise',
      'dataApi[rows]=9999'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiResult<Expertise>) => {
        return response;
      });
  }

  /**
   * Gets distinct values for expertises.
   *
   * @param {ExpertiseSettings|null} [settings] Plugin settings
   * @returns {Promise<DataApiDistinctValues>}
   */
  public async distinctValues(settings: ExpertiseSettings | null = null): Promise<DataApiDistinctValues> {
    return fetch(this.buildUrl(settings, null, [
      'dataApi[preset]=expertise',
      'dataApi[rows]=9999',
      'dataApi[distinctValues]=1'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiDistinctValues) => {
        return response;
      });
  }
}
